import { List, ThemeIcon } from '@mantine/core'
import { RiHome5Line } from '@remixicon/react'

import ListClasses from './List.module.css'

export const DashboardLinks = () => {
  const isActive = (path: string) => {
    const location = window.location.pathname

    return path === location || path?.endsWith(location)
  }
  return (
    <List classNames={ListClasses} spacing='xs'>
      <List.Item
        icon={
          <ThemeIcon color='rgba(255, 255, 255, 0.4)' size={30} radius='xl'>
            <RiHome5Line size={16} />
          </ThemeIcon>
        }
        data-active={
          isActive(`${process.env.NEXT_PUBLIC_BASE_URL}/global-portal`) &&
          'true'
        }
      >
        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/global-portal`}>
          Common Dashboard
        </a>
      </List.Item>
      <List.Item
        icon={
          <ThemeIcon color='rgba(255, 255, 255, 0.2)' size={30} radius='xl'>
            <span style={{ fontWeight: 'bold' }}>C</span>
          </ThemeIcon>
        }
        data-active={
          isActive(`${process.env.NEXT_PUBLIC_BASE_URL}/co-owner/dashboard`) &&
          'true'
        }
      >
        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/co-owner/dashboard`}>
          Partment C
        </a>
      </List.Item>
      <List.Item
        icon={
          <ThemeIcon color='rgba(255, 255, 255, 0.2)' size={30} radius='xl'>
            <span style={{ color: '#668FFF', fontWeight: 'bold' }}>L</span>
          </ThemeIcon>
        }
        data-active={
          isActive(`${process.env.NEXT_PUBLIC_BASE_URL}/landlord/dashboard`) &&
          'true'
        }
      >
        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/landlord/dashboard`}>
          Partment L
        </a>
      </List.Item>
    </List>
  )
}
